/**
 * Media Picker Component
 * Modal for selecting media from the library
 */

import React from 'react';
import { MediaItem, MediaType } from '../../types';
import MediaGallery from './MediaGallery';
import './MediaPicker.css';

interface MediaPickerProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect?: (item: MediaItem) => void;
  onSelectMultiple?: (items: MediaItem[]) => void;
  allowMultiple?: boolean;
  allowedTypes?: MediaType[];
  title?: string;
}

export const MediaPicker: React.FC<MediaPickerProps> = ({
  isOpen,
  onClose,
  onSelect,
  onSelectMultiple,
  allowMultiple = false,
  allowedTypes,
  title = 'Select Media',
}) => {
  if (!isOpen) return null;

  const handleSelect = (item: MediaItem) => {
    onSelect?.(item);
    onClose();
  };

  const handleSelectMultiple = (items: MediaItem[]) => {
    onSelectMultiple?.(items);
    onClose();
  };

  return (
    <div className="media-picker-overlay" onClick={onClose}>
      <div className="media-picker-modal" onClick={(e) => e.stopPropagation()}>
        <div className="media-picker-header">
          <h3>{title}</h3>
          <button className="close-picker" onClick={onClose}>×</button>
        </div>
        <div className="media-picker-body">
          <MediaGallery
            onSelect={allowMultiple ? undefined : handleSelect}
            onSelectMultiple={allowMultiple ? handleSelectMultiple : undefined}
            selectionMode={!allowMultiple}
            selectionModeMulti={allowMultiple}
            allowedTypes={allowedTypes}
            showUploader
          />
        </div>
      </div>
    </div>
  );
};

export default MediaPicker;
